import { useState, useEffect } from "react";
import { FormControl, FormLabel, Text, VStack } from "@chakra-ui/react";
import StrongModal from "../common/StrongModal";
import StrongInput from "../common/StrongInput";
import StrongImageDragDrop from "../common/StrongImageDragDrop";
import StrongRichText from "../common/StrongRichText";
import StrongSelect from "../common/StrongSelect";
import StrongCheckBox from "../common/StrongCheckBox";        

interface ProgramSettingsModalProps {
isOpen: boolean;
onClose: () => void;
woocommerceVariationId: string;
purchaseLink: string;
introVimeoId: string;
thumbnail: string;
shortDescription: string;
description: string;
cover: string;
equipmentstitle: EquipmentTitle[];                          
resourcestitle: ResourceTitle[];                            
selectedequipments: string[];                               
selectedresources: string[];
 selectedgenders?: string[];
 isFeatured?: boolean;
 onSave: (
    variationId: string,
     purchaseLink: string,
    cover: File | null,
    thumbnail: File | null,
    shortDescription: string,
    description: string,
    introVimeoId: string,
    selectedequipments: string[],
    selectedresources: string[],
    selectedgenders?: string[],
    isFeatured?: boolean,
    coverRemoved?: boolean,
    thumbnailRemoved?: boolean,
) => void;
}

const ProgramSettingsModal = ({
isOpen,
onClose,
woocommerceVariationId,
purchaseLink,
cover,
thumbnail,
shortDescription,
description,
    introVimeoId,
equipmentstitle,        // add this
    resourcestitle,         // add this
selectedequipments: selectedequipmentsProp,             
selectedresources: selectedresourcesProp,
onSave,
 selectedgenders,
 isFeatured: isFeaturedProp = false,
}: ProgramSettingsModalProps) => {
    
const [variationId, setVariationId] = useState<string>("");
const [purchaseLinkState, setPurchaseLinkState] = useState<string>("");
const [thumbnailFile, setThumbnailFile] = useState<File |        
  null>(null);                                                     
  const [thumbnailPreview, setThumbnailPreview] =                  
        useState<string>(thumbnail || "");    
  const [thumbnailRemoved, setThumbnailRemoved] = useState(false);
  const [coverFile, setCoverFile] = useState<File |        
  null>(null);                                                     
  const [coverPreview, setCoverPreview] =                  
  useState<string>(cover || "");       
  const [coverRemoved, setCoverRemoved] = useState(false);
  const [shortDescriptionState, setShortDescriptionState] = useState<string>(shortDescription || "");
  const [descriptionState, setDescriptionState] = useState<string>(description || "");
    const [introVimeoIdState, setIntroVimeoId] = useState<string>(introVimeoId || "");
    
const [selectedequipments, setSelectedEquipments] =         
  useState<string[]>([]);                            
const [selectedresources, setSelectedResources] =           
  useState<string[]>([]); 
const [selectedGenders, setSelectedGenders] = useState<string[]>(selectedgenders || []);
const [isFeaturedState, setIsFeaturedState] = useState<boolean>(isFeaturedProp);

useEffect(() => {
    setVariationId(woocommerceVariationId || "");
    setPurchaseLinkState(purchaseLink || "");
    setShortDescriptionState(shortDescription || "");
    setDescriptionState(description || "");
    setIntroVimeoId(introVimeoId || "");
    setSelectedEquipments(selectedequipmentsProp || []);
  setSelectedResources(selectedresourcesProp || []);
    setSelectedGenders(selectedgenders || []);
    setIsFeaturedState(isFeaturedProp ?? false);
}, [woocommerceVariationId, purchaseLink, shortDescription, description, introVimeoId, selectedequipmentsProp, selectedresourcesProp, selectedgenders, isFeaturedProp]);

    useEffect(() => {                                                
    setThumbnailPreview(thumbnail || "");                          
    setThumbnailFile(null);                                        
    setThumbnailRemoved(false);
    setCoverPreview(cover || "");                                  
    setCoverFile(null);                                            
    setCoverRemoved(false);
    }, [isOpen]); 
    
return (
    <StrongModal
    isOpen={isOpen}
    onClose={onClose}
        onSubmit={() => {
                console.log('ProgramSettingsModal Submit - Payload being sent:');
                console.log({
                  variationId,
                  purchaseLink: purchaseLinkState,
                  coverFile: coverFile ? `File: ${coverFile.name}` : null,
                  thumbnailFile: thumbnailFile ? `File: ${thumbnailFile.name}` : null,
                  shortDescription: shortDescriptionState,
                  description: descriptionState,
                  introVimeoId: introVimeoIdState,
                  selectedequipments,
                  selectedresources,
                  selectedGenders,
                });
                onSave(
                    variationId,
                    purchaseLinkState,
                    coverFile,
                    thumbnailFile,
                    shortDescriptionState,
                    descriptionState,
                    introVimeoIdState,
                    selectedequipments,
                    selectedresources,
                    selectedGenders,
                    isFeaturedState,
                    coverRemoved,
                    thumbnailRemoved,
                );
                onClose();
        }}
    title="Program Settings"
    body={
        <VStack spacing={4} align="stretch">
        <FormControl>
            <FormLabel color="gray.600">WooCommerce Variation ID</FormLabel>
            <StrongInput
            placeholder="Enter WooCommerce Variation ID"
            value={variationId}
            onChange={(e) => setVariationId(e.target.value)}
            />
            </FormControl>
            <FormControl>
                <FormLabel color="gray.600">Purchase Link</FormLabel>
                <StrongInput
                    placeholder="Enter buy now / payment link"
                    value={purchaseLinkState}
                    onChange={(e) => setPurchaseLinkState(e.target.value)}
                />
            </FormControl>
            <FormControl>                           
                <FormLabel color="gray.600">Cover</FormLabel>
                <Text fontSize="sm" color="gray.500" mb={2}> Ideal size: 1000 × 600 px (5:3). Other sizes will be
            displayed in cover mode without stretching or distortion.</Text>                                       
                <StrongImageDragDrop 
                onFileSelect={(file) => {
                    setCoverFile(file);
                    setCoverPreview(file ? URL.createObjectURL(file) : "");
                    setCoverRemoved(!file);
                }}
                defaultImageUrl={coverPreview}         
                />                                                             
            </FormControl>

             <FormControl>                           
                <FormLabel color="gray.600">Thumbnail</FormLabel>
                <Text fontSize="sm" color="gray.500" mb={2}> Ideal size: 1000 × 600 px (5:3). Other sizes will be
            displayed in cover mode without stretching or distortion.</Text>                                       
                <StrongImageDragDrop 
                onFileSelect={(file) => {
                    setThumbnailFile(file);
                    setThumbnailPreview(file ? URL.createObjectURL(file) : "");
                    setThumbnailRemoved(!file);
                }}
                defaultImageUrl={thumbnailPreview}         
                />                                                             
            </FormControl>

            <FormControl>
                <FormLabel color="gray.600">Intro Vimeo ID</FormLabel>
                <StrongInput
                    placeholder="Enter intro Vimeo ID"
                    value={introVimeoIdState}
                    onChange={(e) => setIntroVimeoId(e.target.value)}
                />
            </FormControl>

            <FormControl>
                <FormLabel color="gray.600">Short Description</FormLabel>
                <StrongInput
                    placeholder="Enter short description"
                    value={shortDescriptionState}
                    onChange={(e) => setShortDescriptionState(e.target.value)}
                />
            </FormControl>
            <FormControl>
                <FormLabel color="gray.600">Description</FormLabel>
                <StrongRichText
                    placeholder="Enter description"
                    value={descriptionState}
                    onChange={setDescriptionState}
                />
            </FormControl>

             <FormControl>                                               
            <FormLabel color="gray.600">Equipment</FormLabel>         
            <StrongSelect                                           
            options={equipmentstitle?.map(({ title, id }) => ({     
        label: title, value: id })) || []}                     
            value={selectedequipments.map((value) => {              
                const eq = equipmentstitle?.find((e) => e.id ===    
        value);                                                     
                if (!eq) return null;                               
                return { label: eq.title, value: eq.id };             
            }).filter((o): o is { label: string; value: string } =>
        o !== null)}                                                
            onSelectChange={setSelectedEquipments}
            />                                                        
        </FormControl>                                              
                        
        <FormControl>                                               
            <FormLabel color="gray.600">Resources</FormLabel>       
            <StrongSelect                                    
            options={resourcestitle?.map(({ title, _id }) => ({
        label: title, value: _id })) || []}                    
            value={selectedresources.map((value) => {               
                const res = resourcestitle?.find((r) => r._id ===
        value);                                                     
                if (!res) return null;                              
                return { label: res.title, value: res._id };
            }).filter((o): o is { label: string; value: string } =>
        o !== null)}                                                
            onSelectChange={setSelectedResources}
            />                                                        
        </FormControl> 
        <FormControl>
            <FormLabel color="gray.600">Gender</FormLabel>
            <StrongSelect
              options={[{ label: "Male", value: "male" }, { label: "Female", value: "female" }]}
              value={selectedGenders.map((g) => ({ label: g[0].toUpperCase() + g.slice(1), value: g }))}
              onSelectChange={setSelectedGenders}
            />
        </FormControl>
        <FormControl>
            <FormLabel color="gray.600">Featured</FormLabel>
            <StrongCheckBox
              isChecked={isFeaturedState}
              onCheckChange={setIsFeaturedState}
            />
        </FormControl>
        </VStack>
    }
    />
);
};

export default ProgramSettingsModal;

// this is created by jitendra (18-04-2026) to add woocommerce variation id in program info and program edit page.
